'use client';
import type { PropsWithChildren } from 'react';
import { css } from '@styled-system/css';
import { Box } from '@styled-system/jsx';

type Props = PropsWithChildren<{
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}>;

export const EpisodeItemOuter = ({ onClick, children }: Props) => {
  return (
    <Box
      className={css({
        borderBottom: '1px solid #d7d8da',
        _lastOfType: {
          borderBottom: 'none',
          _hover: {
            borderBottom: 'none',
          },
        },
        _hover: {
          borderBottom:
            '1px solid transparent' /* 非表示になるとガタガタするから透明に */,
        },
      })}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
